import { StyledTagType } from '../../../ui-toolkit';

export enum eCommentType {
  accountVerification = 'account_verification',
  closing = 'closing',
  curative = 'curative',
  escrowOps = 'escrow_ops',
  examination = 'examination',
  funding = 'funding',
  general = 'general',
  inboundCall = 'inbound_call',
  orderManagement = 'order_management',
  policy = 'policy',
  postClosing = 'post_closing',
  postClosingEscalation = 'post_closing_escalation',
  questionnaire = 'questionnaire',
  recording = 'recording',
  search = 'search',
  shortage = 'shortage',
  signing = 'signing',
  underwriting = 'underwriting',
  tenNinetyNine = '_1099',
  payoff = 'payoff',
  postFunding = 'post_funding',
  postSigning = 'post_signing',
  recordingShortage = 'recording_shortage',
  recordingOverage = 'recording_overage',
  taxCertification = 'tax_certification',
  titleSearch = 'title_search',
}

export const prettyCommentsType: Record<eCommentType, string> = {
  [eCommentType.accountVerification]: 'Account Verification',
  [eCommentType.closing]: 'Closing',
  [eCommentType.curative]: 'Curative',
  [eCommentType.escrowOps]: 'Escrow Ops',
  [eCommentType.examination]: 'Examination',
  [eCommentType.funding]: 'Funding',
  [eCommentType.general]: 'General',
  [eCommentType.inboundCall]: 'Inbound Call',
  [eCommentType.orderManagement]: 'Order Management',
  [eCommentType.policy]: 'Policy',
  [eCommentType.postClosing]: 'Post Closing',
  [eCommentType.postClosingEscalation]: 'Post Closing Escalation',
  [eCommentType.questionnaire]: 'Questionnaire',
  [eCommentType.recording]: 'Recording',
  [eCommentType.search]: 'Search',
  [eCommentType.shortage]: 'Shortage',
  [eCommentType.signing]: 'Signing',
  [eCommentType.underwriting]: 'Underwriting',
  [eCommentType.tenNinetyNine]: '_1099',
  [eCommentType.postFunding]: 'Post Funding',
  [eCommentType.postSigning]: 'Post Signing',
  [eCommentType.recordingShortage]: 'Recording Shortage',
  [eCommentType.recordingOverage]: 'Recording Overage',
  [eCommentType.payoff]: 'Payoff',
  [eCommentType.titleSearch]: 'Title Search',
  [eCommentType.taxCertification]: 'Tax Certification',
};

export const commentTypeColor: Record<eCommentType, StyledTagType> = {
  [eCommentType.accountVerification]: 'gray',
  [eCommentType.closing]: 'gray',
  [eCommentType.curative]: 'gray',
  [eCommentType.escrowOps]: 'gray',
  [eCommentType.examination]: 'gray',
  [eCommentType.funding]: 'gray',
  [eCommentType.general]: 'gray',
  [eCommentType.inboundCall]: 'gray',
  [eCommentType.orderManagement]: 'gray',
  [eCommentType.policy]: 'gray',
  [eCommentType.postClosing]: 'gray',
  [eCommentType.postClosingEscalation]: 'gray',
  [eCommentType.questionnaire]: 'gray',
  [eCommentType.recording]: 'gray',
  [eCommentType.search]: 'gray',
  [eCommentType.shortage]: 'gray',
  [eCommentType.signing]: 'gray',
  [eCommentType.underwriting]: 'gray',
  [eCommentType.tenNinetyNine]: 'gray',
  [eCommentType.postFunding]: 'gray',
  [eCommentType.postSigning]: 'gray',
  [eCommentType.recordingShortage]: 'gray',
  [eCommentType.recordingOverage]: 'gray',
  [eCommentType.titleSearch]: 'yellow',
  [eCommentType.payoff]: 'green',
  [eCommentType.taxCertification]: 'blue',
};
